import { EthAddress } from '@xylabs/sdk-js'
import { useAsyncEffect } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { TypedEvent } from '@xyo-network/world-typechain'
import { PropsWithChildren, useContext, useState } from 'react'

import { MinterAuctionContext } from '../Auction'
import { MinterEventsContext } from './Context'

interface Props {
  account?: EthAddress
  enabled?: boolean
  eventType?: string
  quadkey?: Quadkey
}

export const MinterEventsLoader: React.FC<PropsWithChildren<Props>> = (props) => {
  const enabled = true
  const { auction } = useContext(MinterAuctionContext)

  const [eventType, setEventType] = useState(props.eventType ?? 'All')
  const [events, setEvents] = useState<TypedEvent[]>()
  const [refreshCount, setRefreshCount] = useState(0)

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps, complexity
    async (isMounted) => {
      let events: TypedEvent[]
      if (auction && enabled) {
        switch (eventType) {
          case 'TokensFlowed':
            events = (await auction?.events().tokensFlowed()) ?? []
            break
          case 'GeotokenMinted':
            events = (await auction?.events().geoTokenMinted()) ?? []
            break
          case 'BidPlaced':
            events = (await auction?.events().bidPlaced()) ?? []
            break
          case 'MintingFeeSent':
            events = (await auction?.events().mintingFeeSent()) ?? []
            break
          case 'TokensBurned':
            events = (await auction?.events().tokensBurned()) ?? []
            break
          case 'AuctionStarted':
            events = (await auction?.events().auctionStarted()) ?? []
            break
          case 'RefundedCurrentBid':
            events = (await auction?.events().refundedCurrentBid()) ?? []
            break
          default:
            events = (await auction?.events().all()) ?? []
            break
        }
        if (isMounted()) {
          setEvents(events)
        }
      }
    },
    [auction, eventType, refreshCount, enabled],
  )

  const updateEventType = (eventType: string) => {
    setEventType(eventType)
  }

  const refresh = () => {
    setEvents(undefined)
    setRefreshCount(refreshCount + 1)
  }

  return (
    <MinterEventsContext.Provider
      value={{
        eventType,
        events,
        refresh,
        updateEventType,
      }}
    >
      {props.children}
    </MinterEventsContext.Provider>
  )
}
